export class MedicalHistoryModel{
  patientcode = '' ;
  diabetes = '' ;
  diabetessince = 0 ;
  diabetesdays = '' ;
  diabetescontrol = '' ;
  hayper ='' ;
  haypersince = 0 ;
  hayperdays = '' ;
  haypercontrol = '' ;
  hepa = '' ;
  hepasince = 0 ;
  hepadays = '' ;
  hepacontrol = '' ;
  bilh = '' ;
  bilhsince = 0 ;
  bilhdays = '' ;
  bilhcontrol = '' ;
  card = '';
  cardsince = 0 ;
  carddays = '' ;
  cardcontrol = '' ;
  auto = '' ;
  autosince = 0 ;
  autodays = '' ;
  autocontrol = '' ;
  allergy = '' ;
  allergysince = 0 ;
  allergydays = '' ;
  allergycontrol = '' ;
  others = '' ;
  otherssince = 0 ;
  othersdays = '' ;
  otherscontrol = '' ;
  compcode = '1' ;
  userid = 'sa' ;
  modifieddate ='2021-01-01';

}
